import * as z from "zod/v4";

const checkoutTreeEventRowSchema = z.object({
  _id: z.string(),
  kind: z.string(),
  timestamp: z.string(),
  checkoutTreeId: z.string(),
  actor: z.string().optional(),
});

const checkoutTreeNodeSummarySchema = z.object({
  segments: z.number(),
  splits: z.number(),
  checkoutExperiences: z.number(),
});

export type CheckoutTreeNodeSummary = z.infer<
  typeof checkoutTreeNodeSummarySchema
>;

const checkoutTreeRecordSchema = z.object({
  _id: z.string(),
  createdAt: z.string(),
  creator: z.string().optional(),
  summary: checkoutTreeNodeSummarySchema.optional(),
});

export const getCheckoutTreeRecords = {
  name: "getCheckoutTreeRecords" as const,
  input: z.null(),
  output: z.object({
    records: z.array(checkoutTreeRecordSchema),
    activeCheckoutTreeId: z.string().optional(),
    events: z.array(checkoutTreeEventRowSchema),
  }),
};

export type GetCheckoutTreeRecordsOutput = z.infer<
  typeof getCheckoutTreeRecords.output
>;
export type CheckoutTreeRecordRow = z.infer<typeof checkoutTreeRecordSchema>;
export type CheckoutTreeEventRow = z.infer<typeof checkoutTreeEventRowSchema>;
